import { TableColumnType } from 'antd';

import { TPracticeType } from '../types';

import { useTableSortColumns } from '@/hooks';
import { PracticeInvite } from '@/modules/practices/components/invite';

export const useColumns = (): TableColumnType<TPracticeType>[] => {
    const sortColumns = useTableSortColumns<TPracticeType>();

    return sortColumns([
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 100,
            sorter: true,
        },
        {
            key: 'name',
            title: 'Name',
            dataIndex: 'name',
            sorter: true,
        },
        {
            key: 'actions',
            title: 'Actions',
            width: 90,
            align: 'center',
            render: (_, record) => {
                return <PracticeInvite practiceId={record.id} />;
            },
        },
    ]);
};
